<template>
  <div>
    <v-dialog v-model="value" persistent max-width="800">
      <v-card>
        <v-card-title primary-title :style="{ 'background-color': $vuetify.theme.primary }">
          <v-layout>
            <v-flex>
              <v-avatar size="50" color="grey">
                <img :src="user.profile_pic" alt="user" />
              </v-avatar>

              <span class="pl-2 white--text">{{ user.first_name }} {{ user.last_name }}</span>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn @click="showExportGroup = true">{{ $t('Export') }}</v-btn>
              <v-btn icon flat @click="$emit('input', false)">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout>
            <v-flex class="headline primary--text">Tag lists & Timestamp</v-flex>
            <v-flex class="text-xs-right">
              <v-btn @click="showFilter = true" :color="searchCount ? 'primary' : ''"
                >Filter {{ searchCount ? `(${searchCount})` : '' }}</v-btn
              >
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="tagList"
            class="elevation-1"
            :pagination.sync="pagination"
            :loading="loading"
            :rowsPerPageItems="rowsPerPageItems"
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.tag }}</td>
              <td>{{ props.item.timestamp | DateFormat('DD MMM YYYY HH:mm') }}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showFilter" max-width="600" persistent>
      <v-card>
        <v-card-text>
          <v-layout>
            <v-flex class="pa-1">
              Start Date
              <DatepickerCustomDialog v-model="filter.startDate">
                <template v-slot="{ computedDate }">
                  <v-text-field
                    class="default-input"
                    outline
                    name="startDate"
                    placeholder="DD/MM/YYYY"
                    readonly
                    :value="computedDate"
                    hide-details
                    single-line
                    clearable
                    @click:clear="filter.startDate = undefined"
                  ></v-text-field>
                </template>
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex class="pa-1">
              End Date
              <DatepickerCustomDialog v-model="filter.endDate">
                <template v-slot="{ computedDate }">
                  <v-text-field
                    class="default-input"
                    outline
                    name="endDate"
                    placeholder="DD/MM/YYYY"
                    readonly
                    :value="computedDate"
                    hide-details
                    single-line
                    clearable
                    @click:clear="filter.endDate = undefined"
                  ></v-text-field>
                </template>
              </DatepickerCustomDialog>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="pa-1">
              Start Time
              <CustomTimepicker
                name="starttime"
                :data-vv-as="'Start time'"
                :value="filter.startTime"
                @onChange="
                  (val) => {
                    filter.startTime = val
                  }
                "
                overlay
                format="HH:mm"
                placeholder="HH:mm"
                onlyTime
                clearable
              >
              </CustomTimepicker>
            </v-flex>
            <v-flex class="pa-1">
              End Time

              <CustomTimepicker
                name="starttime"
                :data-vv-as="'Start time'"
                :value="filter.endTime"
                @onChange="
                  (val) => {
                    filter.endTime = val
                  }
                "
                overlay
                format="HH:mm"
                placeholder="HH:mm"
                onlyTime
                clearable
              >
              </CustomTimepicker>
            </v-flex>
          </v-layout>

          <div class="pa-1">
            Tag
            <v-text-field
              class="default-input"
              outline
              name="tag"
              v-model="filter.tag"
              hide-details
              single-line
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="onClearSearch" outline :loading="loading">{{ $t('Clear Search') }}</v-btn>
          <v-btn @click="onSearch" color="primary" :loading="loading">{{ $t('Search') }}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ExportGroup
      v-model="showExportGroup"
      @onExport="onExportTags"
      :total="total"
      filename="tag-lists"
    ></ExportGroup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import ExportGroup from '@/components/elements/ExportGroup.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker2.vue'
export default {
  props: ['value', 'user'],
  data() {
    return {
      showExportGroup: false,
      loading: false,
      headers: [
        {
          sortable: false,
          text: 'No.'
        },
        {
          sortable: false,
          text: 'Tag Lists',
          value: 'tag'
        },
        {
          sortable: false,
          text: 'Timestamp',
          value: 'timestamp'
        }
      ],
      filter: {
        startDate: undefined,
        endDate: undefined,
        startTime: undefined,
        endTime: undefined,
        tag: undefined
      },
      tagList: [],
      total: 0,
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: { rowsPerPage: 20 },
      showFilter: false
    }
  },
  components: {
    ExportGroup,
    DatepickerCustomDialog,
    CustomTimepicker
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    searchCount() {
      let count = 0
      for (const key in this.filter) {
        if (Object.hasOwnProperty.call(this.filter, key)) {
          const element = this.filter[key]
          if (element) count++
        }
      }
      return count
    }
  },
  methods: {
    async onExportTags(callback) {
      if (callback) {
        this.loading = true
        let { limit, offset } = callback
        let { items } = await this.getUserTagListByUserId(limit, offset)
        let formatItems = items.map((tag) => {
          return [tag.tag, tag.timestamp]
        })

        callback.submitAoaData([
          [' Customer Name', `${this.user.first_name} ${this.user.last_name}`],
          [],
          ['Tag Lists', 'Timestamp'],
          ...formatItems
        ])
        this.loading = false
      }
    },
    async onClearSearch() {
      this.filter = {
        startDate: undefined,
        endDate: undefined,
        startTime: undefined,
        endTime: undefined,
        tag: undefined
      }
      this.onSearch()
    },
    async onSearch() {
      this.loading = true
      const { items, total } = await this.handleGetUserTagListByUserId()
      this.tagList = items
      this.total = total
      this.loading = false
      this.showFilter = false
      this.$set(this.pagination, 'page', 1)
    },
    async handleGetUserTagListByUserId() {
      const { page, rowsPerPage } = this.pagination
      const offset = (page - 1) * rowsPerPage,
        limit = rowsPerPage
      return await this.getUserTagListByUserId(limit, offset)
    },
    async getUserTagListByUserId(limit, offset) {
      for (const key in this.filter) {
        if (Object.hasOwnProperty.call(this.filter, key)) {
          const element = this.filter[key]
          if (!element) this.$set(this.filter, key, undefined)
        }
      }
      const data = {
        pageId: this.selectedBot.pageid,
        userId: this.user.id,
        limit: limit,
        offset: offset,
        ...this.filter
      }

      const response = await api.postUserTagListByUserId(data)

      return {
        items: response.data || [],
        total: response.total || 0
      }
    }
  },
  watch: {
    pagination: {
      async handler() {
        this.loading = true
        const { items, total } = await this.handleGetUserTagListByUserId()
        this.tagList = items
        this.total = total
        this.loading = false
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/NestleTagsTimestamp.vue